import isObject from 'lodash/isObject';
import values from 'lodash/values';

/**
 * Валидатор свойст компоненты, который пропускает только разрешенные значения
 *
 * @param {Array<T> | Record<unknown, T>} options
 * @returns {(prop: unknown) => boolean}
 * @constructor
 */
export function OneOf<T = string>(options: Array<T> | object): (prop: unknown) => boolean {
  // eslint-disable-next-line func-names
  return function (prop: unknown): boolean {
    if (isObject(options)) {
      return values(options as {}).includes(prop);
    }
    return (options as Array<unknown>).includes(prop as T);
  };
}
